import React, { useEffect, useRef, useState } from 'react';

import { connect } from 'react-redux';

import { DownOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';

import history from '../../history';
import { Company } from '../../models/Company';
import { User } from '../../models/User';

interface Props {
    user: User;
    company: Company;
}

const UserMenu = (props: Props) => {
    const { user, company } = props;
    const [open, setOpen] = useState(false);
    const rootRef = useRef<HTMLDivElement>(null);

    const isLegal = company?.company_type === 'legal';
    const fio = [user?.surname, user?.name, user?.patronymic].filter(Boolean).join(' ').trim();
    const baseName = isLegal
        ? company?.name || 'Организация'
        : fio || user?.username || user?.email || 'Пользователь';
    const displayName = baseName.toString();
    const initial = displayName.trim().charAt(0).toUpperCase();

    useEffect(() => {
        const onClick = (e: MouseEvent) => {
            if (rootRef.current && !rootRef.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setOpen(false);
        };
        document.addEventListener('mousedown', onClick);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onClick);
            document.removeEventListener('keydown', onKey);
        };
    }, []);

    const goProfile = () => {
        setOpen(false);
        history.push('/profile');
    };

    const logout = () => {
        setOpen(false);
        localStorage.removeItem('token');
        history.push('/login');
    };

    return (
        <div className="user-menu" ref={rootRef}>
            <button type="button" className="user-trigger" onClick={() => setOpen((v) => !v)}>
                <span className="user-avatar">{initial}</span>
                <span className="user-name">{displayName}</span>
                <DownOutlined className="user-caret" />
            </button>

            {open && (
                <div className="user-dropdown">
                    <button type="button" className="user-dd-item" onClick={goProfile}>
                        <UserOutlined /> Личные данные
                    </button>
                    <button type="button" className="user-dd-item danger" onClick={logout}>
                        <LogoutOutlined /> Выйти
                    </button>
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (state: any) => ({
    user: state.user.user,
    company: state.company.company,
});

export default connect(mapStateToProps)(UserMenu);
